import React, { useEffect, useState } from 'react'
import { Panel } from 'primereact/panel'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import './ImportVinculoRotaClienteMassa.css'
import { PageHeader, Btn, TextBtn, ImportExcelFile, Cnpj } from '../../../../components'
import { tableCellCentered } from '../../../../assets/js/styles'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'
import { saveClienteRotaMassively } from '../../../../services/api/https/system/system.http'
import ExcelModeloBuilderMultiSheet from '../../../../components/ExcelModeloBuilderMultiSheet/ExcelModeloBuilderMultiSheet'

const ImportVinculoRotaClienteMassa = ({ selectedTp, history, dispatch }) => {
  const modeloExcel = [['cnpj/cpf (string)*', 'nome_rota (string)*']]

  const modelos = [
    {
      wsName: 'Modelo',
      colunas: modeloExcel,
    },
  ]

  const [ClienteRota, setClienteRota] = useState([])

  const onBtnSalvarClicked = async () => {
    dispatch(showLoadingBox('Aguarde...', 'Carregando...'))
    try {
      if (selectedTp === '') {
        throw new Error('Selecione um TP')
      }
      if (ClienteRota.length === 0) {
        throw new Error('Não existem Cliente/Rota para Importação')
      }
      await saveClienteRotaMassively(selectedTp, ClienteRota)
      dispatch(showMessageBox('Vínculo realizado com sucesso', null))
      setClienteRota([])
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    } finally {
      dispatch(hideLoadingBox())
    }
  }

  const onBtnVoltarClicked = () => {
    history.goBack()
  }

  const _planilhaNoPadrao = content => {
    const header = content[0]
    return header[0] === 'cnpj/cpf (string)*' && header[1] === 'nome_rota (string)*'
  }

  const _buildClienteRota = content => {
    const body = content.slice(1)
    const result = []
    for (let index = 0; index < body.length; index++) {
      const row = body[index]
      const cnpj_cnpf = row[0] ? row[0].toString().replace(/\D/g, '').trim() : ''

      if ((cnpj_cnpf.length !== 11 && cnpj_cnpf.length !== 14) || !row[1]) {
        throw new Error(`Erro próximo a linha ${index + 2} da planilha. Conteúdo inconsistente.`)
      }

      result.push({
        cnpj: cnpj_cnpf,
        nome_rota: row[1].trim(),
      })
    }
    return result
  }

  const onFileImported = content => {
    try {
      const isPlanilhaNoPadrao = _planilhaNoPadrao(content)
      if (!isPlanilhaNoPadrao) {
        throw new Error('Planilha Fora do Padrão. Baixe o Modelo e Verifique.')
      }
      setClienteRota(_buildClienteRota(content))
    } catch (error) {
      dispatch(showMessageBox(null, error.message))
    }
  }

  useEffect(() => {
    if (selectedTp === 0) {
      dispatch(showMessageBox(null, 'Selecione um TP'))
    } else if (ClienteRota.length > 0) {
      setClienteRota(prevState => {
        return prevState.map(veiculo => {
          return { ...veiculo, tp_id: selectedTp }
        })
      })
    }
  }, [selectedTp])

  return (
    <div>
      <PageHeader>
        <span>S.25 - Importação de Vínculo Rota/Cliente em Massa</span>
      </PageHeader>
      <div style={{ marginTop: 20 }}>
        <Panel>
          <div className="p-grid">
            <div className="p-col-9" style={{ paddingTop: 35 }}>
              <div style={{ display: 'inline-block', marginLeft: 10 }}>
                <ExcelModeloBuilderMultiSheet
                  modelos={modelos}
                  filename="ImportacaoClienteRota.xlsx"
                />
              </div>
              <div style={{ display: 'inline-block', marginLeft: 10 }}>
                <ImportExcelFile
                  label="Importar"
                  classes="btnImportar"
                  onFileImported={onFileImported}
                />
              </div>

              <div style={{ display: 'inline-block', marginLeft: 10 }}>
                <Btn onClick={onBtnSalvarClicked} disabled={!selectedTp}>
                  Salvar
                </Btn>
              </div>
              <div style={{ display: 'inline-block', marginLeft: 10 }}>
                <TextBtn onClick={onBtnVoltarClicked}>Voltar</TextBtn>
              </div>
            </div>
          </div>
          <div>
            <DataTable value={ClienteRota}>
              <Column
                field="cnpj"
                header="CNPJ/CPF"
                style={tableCellCentered(230)}
                body={customer => <Cnpj>{customer.cnpj}</Cnpj>}
              />
              <Column field="nome_rota" header="Rota" />
            </DataTable>
          </div>
        </Panel>
      </div>
    </div>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(ImportVinculoRotaClienteMassa))
